import React from 'react';
import { withRouter } from 'react-router';
import { Message } from 'dab-component-lib';
import I18n from '../../I18n/I18n';

import { GridContainerStyle} from '../../utils/style-utils';

const ErrorPage = () => {
  return (
    <GridContainerStyle>
      <Message title={I18n.t('errors.generalError')} />
    </GridContainerStyle>
  );
};

export default withRouter(ErrorPage);


// WEBPACK FOOTER //
// ./src/components/errorPage/index.js